<template>

  <v-dialog v-model="dialog" scrollable width="80%">
    <v-card>

      <v-card color="transparent" flat>
        <v-card-text class="font-weight-light text-xs-left title underlineheadline bluetext">
          {{cardTitle}}
        </v-card-text>
      </v-card>
      <v-card-text>
        <v-layout row wrap justify-start>
          <v-flex>
            <v-card flat>
              <v-card-title>
                <span v-html="description"></span>
              </v-card-title>

              <v-card-text justify-start>
                <v-layout  row wrap justify-start>
                  <v-flex v-for="(group,i) in groups" v-bind:key="i" class="groupButton text-xs-left">
                    <v-btn @click="selectGroup(group)" class="examenis block" dark v-if="group.isTanActiv">{{group.id}} - {{group.title}}</v-btn>
                    <v-btn @click="selectGroup(group)" class="examenis block" v-if="!group.isTanActiv" disabled>{{group.id}} - {{group.title}}</v-btn>
                    <span v-if="group.lastLogin && group.lastLogin !== '2000-02-01 00:00:00'">Zuletzt angemeldet am: {{group.lastLogin}}</span>
                    <br>
                    <span v-if="!group.isTanActiv" style="color:red;" class="pl-2">Ihre TAN ist nicht aktiv !</span>
                  </v-flex>

                </v-layout>
              </v-card-text>

            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="dialog=false" color="red darken-4" small dark outline
               class="radiusBtn text-none">abbrechen
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- <v-dialog v-model="dialog" scrollable width="800px">
     <v-card>
       <v-card-title class="borderbluebottom">

         <span class="font-weight-thin bluetext headline">Neuen Bogen erstellen</span>
         <v-spacer></v-spacer>

       </v-card-title>
       <v-card-text>
         <v-layout row wrap justify-start>
           <v-flex>
           <span class="font-weight-thin ">
           Hier können Sie einen neuen Bogen erstellen.
             </span>
           </v-flex>
         </v-layout>
         <v-layout row wrap justify-space-around>
           <v-flex md12>
             <v-text-field
               label="Bogenname"
               box
               color="examenis"
               background-color="examenishell"
               v-model="title"
             ></v-text-field>
           </v-flex>
           <v-flex md12 class="bordernone borderone textfieldsmaller pt-4">
             <Subjects v-model="mySubjects"></Subjects>
           </v-flex>
         </v-layout>

       </v-card-text>
       <v-card-actions>
         <v-btn @click="dialog=false" color="examenis" dark large round outline
                class="font-weight-bold radiusBtn text-none">abbrechen
         </v-btn>
         <v-spacer></v-spacer>
         <v-btn @click="createNewItem" color="examenis" dark large round outline
                class="font-weight-bold radiusBtn text-none">Erstellen
         </v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>-->
</template>

<script>
  // import Subjects from './../Einstellungen/Subjects'

  export default {
    name: 'DialogGroupSelect',
    components: {},
    methods: {
      selectGroup: function (group) {
        this.$emit('onSelect', group)
        this.dialog = false
      },
      /**
       * {newName, title, type, description}
       * @param cardConfig
       */
      open: function (groups) {
        this.groups = groups
        this.dialog = true
      }
    },
    data () {
      return {
        groups: [],
        cardTitle: 'Aktuell sind mehr als eine Prüfung für Sie online.',
        type: 'group',
        pwOld: '',
        pwNew: '',
        pwNew2: '',
        imageLayout: '0',
        questionTyp: '1',
        mySubjects: {},
        description: 'Bitte wählen Sie eine Prüfung',
        dialog: false
      }
    },
    mounted () {
      // Vue.prototype.$api.checkCredentials(this)
    }
  }
</script>

<style scoped>
  .groupButton{
  }

</style>



// WEBPACK FOOTER //
// src/components/dialogs/DialogGroupSelect.vue